import { formatReportNumber } from '../../../../../features/formatters'

export const getOptions = legendContainerId => {
  return {
    elements: {
      arc: {
        borderWidth: 0,
        offset: 40
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: tooltipItem => formatReportNumber({ value: tooltipItem.raw, format: 'percentage' })
        }
      },
      htmlLegend: {
        // ID of the container to put the legend in
        containerID: legendContainerId
      },
      datalabels: {
        formatter: value => `${value}%`,
        align: 'start',
        anchor: 'end',
        font: {
          size: 15,
          weight: 700
        }
      }
    }
  }
}
